export default __webpack_public_path__ + "static/media/yellow_pawn.d96b5ddc.png";